// extracted by mini-css-extract-plugin
export default {"svg":"PresetImage-module__svg--buuQE","img":"PresetImage-module__img--HM_bY"};